import { useMemo } from 'react';

export default () =>
  useMemo(
    () => ({
      pageSize: 10,
    }),
    [],
  );
